<template>
  <div class="no-goal-alert" v-if="showNoGoalBanner">
    <i class="fa-solid fa-triangle-exclamation no-goal-alert__icon"></i>
    <div class="no-goal-alert__text">
      <b>Вы ещё не указали цель на этот сезон.</b>
      Без цели ваши результаты не&nbsp;попадут в&nbsp;рейтинг кластера.
    </div>
    <router-link to="/season/start" class="no-goal-alert__link">
      Указать цель
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoGoalAlert',

  computed: {
    ...mapGetters('season', ['showNoGoalBanner']),
  },
}
</script>

<style>
.no-goal-alert {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff7e3;
  border: 1px solid #f0c878;
  border-radius: 10px;
  padding: 12px 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1.5;
  color: #5a3b00;
}

.no-goal-alert__icon {
  flex-shrink: 0;
  font-size: 18px;
  color: #c9881a;
}

.no-goal-alert__text {
  flex: 1;
  min-width: 0;
}

.no-goal-alert__text b {
  font-weight: 700;
  margin-right: 4px;
}

.no-goal-alert__link {
  flex-shrink: 0;
  padding: 8px 14px;
  background: #c9881a;
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  transition: background 0.2s;
}

.no-goal-alert__link:hover {
  background: #a86f11;
  color: #fff;
}

@media screen and (max-width: 760px) {
  .no-goal-alert {
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .no-goal-alert__text {
    flex-basis: calc(100% - 32px);
  }

  .no-goal-alert__link {
    width: 100%;
    text-align: center;
  }
}
</style>
